import { useEffect, useState } from "react";
import { getFbPagesApi } from "../apiServices/fbPageServices";

const useFbPages = () => {

  const [pages, setPages] = useState([]);

  const fetchPages = async () => {
    try {
      const res = await getFbPagesApi();
      setPages(res?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchPages();
  }, []);

  return { pages };
};

export default useFbPages;